import type { NavSubmenuLinkProps } from '@/types';
import * as Styled from './MenuToggle.styled';
import { NavItem } from './NavItem';

interface LinkSectionProps {
  links: NavSubmenuLinkProps[];
}

export const UtilityLinks = ({ links }: LinkSectionProps) => (
  <Styled.UtilityLinks aria-label="Main navigation">
    <ul>
      {links.map(link => (
        <NavItem key={link.href} link={link} />
      ))}
    </ul>
  </Styled.UtilityLinks>
);
